import SplitPdfTable from "../SplitPdfTable";
import { Close, Download } from "@mui/icons-material";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    IconButton,
    styled,
} from "@mui/material";
import { httpclient } from "../../utils/httpClient";
import { useEffect, useState } from "react";

const StyledHeaderTitle = styled(DialogTitle)(({ theme }) => ({
    background: theme.palette.primary.main,
    color: "#fff",
    position: "relative",
    "& button": {
        position: "absolute",
        right: "15px",
        top: "15px",
        color: "#fff",
    },
}));

const SplitPdfModal = ({ open, onClose, orderID, companyId }) => {

    const [products, setProducts] = useState([])
    const [loading, setLoading] = useState(false)
    const [downloadingBasic, setDownloadingBasic] = useState(false);
    const [downloadingBase64, setDownloadingBase64] = useState(false);


    useEffect(() => {
        getProducts()
    }, [])


    const getProducts = async () => {
        setLoading(true);
        const response = await httpclient.get(
            `new-system/netsuite/exceptional-report/split-label-pdf/${orderID}`
        );

        const rawProducts = response?.data?.data || [];

        const transformed = rawProducts.map((product) => ({
            product: `${product.stockNameDefault} (${product.stockCode})`,
            boxes: product.items.map((item) => ({
                name: item.boxItemName,
                pdfUrl: item.splitPdf,
                base64Url: item.splitPdfBase64,
            })),
        }));

        setProducts(transformed);
        setLoading(false);
    };



    const productColumns = [

        { key: 'pdf', label: 'Download PDF' },
        ...(companyId === 29 ? [{ key: 'base64', label: 'Download Base64' }] : []),
    ];

    const data = [
        {
            product: 'Verona Buffet 4 Doors (UH10048)',
            orderId: 'UH10048',
            boxes: [
                { name: 'Box 1 - 1', pdfUrl: '#', base64Url: '#' },
                { name: 'Box 1 - 2', pdfUrl: '#', base64Url: '#' },
                { name: 'Box 1 - 3', pdfUrl: '#', base64Url: '#' }
            ]
        },
        {
            product: 'Verona Bedside 1 Drw Wal/Blk (UH2121)',
            orderId: 'UH2121',
            boxes: [
                { name: 'Box 1 - 1', pdfUrl: '#', base64Url: '#' },
                { name: 'Box 1 - 2', pdfUrl: '#', base64Url: '#' }
            ]
        }
    ];

    const handleDownloadAllBasicLabelPDF = async () => {
        try {
            setDownloadingBasic(true);
            const response = await httpclient.get(
                `/new-system/netsuite/exceptional-report/downlaod-split-label-pdf/${orderID}`,
                { responseType: 'blob' } // important for binary download
            );

            const blob = new Blob([response.data], { type: 'application/zip' });
            const url = window.URL.createObjectURL(blob);

            const link = document.createElement('a');
            link.href = url;
            link.download = `Label-${orderID}.zip`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error("ZIP download failed", error);
        } finally {
            setDownloadingBasic(false);
        }
    };

    const handleDownloadAllBase64LabelPDF = async () => {
        try {
            setDownloadingBase64(true);

            const response = await httpclient.get(
                `/new-system/netsuite/exceptional-report/downlaod-split-label-pdf/${orderID}?isBase64=1`,
                {
                    responseType: 'arraybuffer', // IMPORTANT: Treat response as binary
                }
            );

            const blob = new Blob([response.data], { type: 'application/zip' });

            const link = document.createElement('a');
            link.href = URL.createObjectURL(blob);
            link.download = `Label-${orderID}-base64.zip`; // You can rename the file as needed
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(link.href);
        } catch (error) {
            console.error("Failed to download ZIP file", error);
        } finally {
            setDownloadingBase64(false);
        }
    };


    return (
        <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
            <StyledHeaderTitle id="alert-dialog-title">
                <div>{`Download Label PDFs`}</div>
                <IconButton onClick={onClose}>
                    <Close />
                </IconButton>
            </StyledHeaderTitle>
            <DialogContent >
                <Box display="flex" justifyContent="flex-end" my={3} gap={2}>
                    <Button
                        variant="contained"
                        color="primary"
                        onClick={handleDownloadAllBasicLabelPDF}
                        disabled={downloadingBasic}
                    >
                        {downloadingBasic ? 'Downloading...' : 'Download All PDFs'}
                        <Download style={{ marginLeft: "5px" }} fontSize="small" />
                    </Button>
                    {companyId === 29 ? (
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={handleDownloadAllBase64LabelPDF}
                            disabled={downloadingBase64}
                        >
                            {downloadingBase64 ? 'Downloading...' : 'Download All Base64s'}
                            <Download style={{ marginLeft: "5px" }} fontSize="small" />
                        </Button>
                    ) : null}
                </Box>
                <SplitPdfTable
                    columns={productColumns}
                    data={products}
                    companyId={companyId}
                />
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="primary" variant="outlined">Close</Button>
            </DialogActions>
        </Dialog>
    );
};

export default SplitPdfModal;